module.exports = __webpack_public_path__ + "static/media/07_a_background.2733bfed.jpg";